import { MenuInterface } from '../../core/interfaces/user.interface';

/** Same shape as tables shown in the header search (`app-view-search-table`). */
export interface MenuTableEntry {
  id: number;
  title: string;
  link: string;
  type: number;
  class?: string;
  parentMenu: string;
  category?: string;
  /** Full menu path from the root to the table's parent menu, e.g. "Root / Sub". */
  path: string;
}

function extractTablesFromMenu(
  menu: MenuInterface,
  out: MenuTableEntry[],
  ancestors: string[],
): void {
  const pathTitles = [...ancestors, menu.title].filter((t) => !!t && !!String(t).trim());
  if (menu.tables?.length) {
    menu.tables.forEach((table) => {
      out.push({
        ...table,
        parentMenu: menu.title,
        category: table.category || menu.title,
        path: pathTitles.join(' / '),
      });
    });
  }
  menu.children?.forEach((child) => extractTablesFromMenu(child, out, pathTitles));
}

/** Walks the user menu tree and returns every table entry (same source as the app header). */
export function extractAllTablesFromMenuRoots(menuItems: MenuInterface[]): MenuTableEntry[] {
  const out: MenuTableEntry[] = [];
  (menuItems || []).forEach((menu) => extractTablesFromMenu(menu, out, []));
  return out;
}
